import { Component, Input, OnInit } from '@angular/core';
import { Screening } from '../models/screeningInvite';
import { ScreeningIncomeOverview } from '../models/argyle';

@Component({
  selector: 'app-income-overview',
  templateUrl: './income-overview.component.html',
  styleUrls: ['./income-overview.component.less']
})
export class IncomeOverviewComponent implements OnInit{
ngOnInit(): void {
  console.log('income',this.incomeOverview)
}
@Input() incomeOverview : ScreeningIncomeOverview;

}
